/**
 * 文字の大きさ（小・中・大）。
 *
 * 船員アプリの文字が小さくて読みにくいという声があるため、端末ごとに選べるようにする。
 * 画面は px 指定が多く個別に直すと漏れるので、ルート要素に倍率をかけて全体を拡大する
 * （CSS transform ではなくフォント基準の zoom 相当。レイアウトはそのまま伸縮する）。
 */
export type FontScale = 'small' | 'medium' | 'large';

const KEY = 'catms_font_scale';

export const FONT_SCALE_OPTIONS: { value: FontScale; label: string; ratio: number }[] = [
  { value: 'small',  label: '小', ratio: 1 },
  { value: 'medium', label: '中', ratio: 1.15 },
  { value: 'large',  label: '大', ratio: 1.3 },
];

export function getFontScale(): FontScale {
  const v = localStorage.getItem(KEY);
  return v === 'medium' || v === 'large' ? v : 'small';
}

/**
 * 選んだ倍率を画面に反映する。
 *
 * 倍率は CSS 変数 --zoom として持たせ、拡大自体は #root に効かせる（styles.css）。
 * html に zoom を当てると 100dvh などが倍率分だけ大きく計算され、
 * 画面の下までスクロールできなくなる／横にはみ出すため、#root 側で寸法を補正している。
 */
export function applyFontScale(scale: FontScale = getFontScale()): void {
  const ratio = FONT_SCALE_OPTIONS.find(o => o.value === scale)?.ratio ?? 1;
  const root = document.documentElement;
  root.style.removeProperty('zoom');       // 旧実装の名残を消す（htmlのzoomは使わない）
  root.style.setProperty('--zoom', String(ratio));
  root.dataset['fontScale'] = scale;
}

export function setFontScale(scale: FontScale): void {
  localStorage.setItem(KEY, scale);
  applyFontScale(scale);
}
